import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type MutationConfig } from 'src/lib/react-query';
import { type GeneralSmartParkError } from 'src/types';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = '/parkings/:parkingId/quick-action/:quickActionId/';

type QuickActionFnType = typeof quickAction;

type QuickActionDTO = {
    parkingId: string;
    quickActionId: string;
};

const quickAction = ({ parkingId, quickActionId, ...data }: QuickActionDTO): Promise<null> => {
    return axios.post(formatResourcePath(RESOURCE, { parkingId, quickActionId }), data);
};

interface UseExitInParkingCardOptions extends MutationConfig<QuickActionFnType, GeneralSmartParkError> {}

const useQuickAction = (options: UseExitInParkingCardOptions = {}) =>
    useMutation({
        mutationFn: quickAction,
        ...options,
    });

export { useQuickAction, quickAction, type QuickActionDTO, RESOURCE };
